document.querySelectorAll('.priority-item').forEach(details => {
    const summary = details.querySelector('summary');
    const content = details.querySelector('.priority-content');

    if (details.open) {
      gsap.set(content, { height: 'auto' });
    } else {
      gsap.set(content, { height: 0, overflow: 'hidden' });
    }

    summary.addEventListener('click', e => {
      e.preventDefault();

      if (details.open) {
        gsap.to(content, {
          height: 0,
          duration: 0.2,
          ease: 'power1.out',
          onComplete: () => details.removeAttribute('open')
        });
      } else {
        details.setAttribute('open', '');
        gsap.fromTo(content,
          { height: 0, overflow: 'hidden' },
          {
            height: content.scrollHeight,
            duration: 0.2,
            ease: 'power1.out',
            onComplete: () => gsap.set(content, { height: 'auto', overflow: 'visible' })
          }
        );
      }
    });

    const copyBtn = details.querySelector('.copy-link-btn');
    const label = copyBtn.querySelector('span');
    copyBtn.addEventListener('click', () => {
      const url = `${window.location.origin}${window.location.pathname}#${details.id}`;
      navigator.clipboard.writeText(url).then(() => {
        label.textContent = 'Copied!';
        copyBtn.classList.add('copied');
        setTimeout(() => {
          label.textContent = 'Copy link';
          copyBtn.classList.remove('copied');
        }, 2000);
      });
    });
  });

  document.querySelectorAll('.share-facebook').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const item = btn.closest('.priority-item');
      const canonical = document.querySelector('link[rel="canonical"]');
      const base = canonical ? canonical.href.replace(/#.*$/, '') : window.location.href.replace(/#.*$/, '');
      const sectionUrl = `${base}#${item.id}`;
      window.open(
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(sectionUrl)}`,
        '_blank',
        'width=600,height=400'
      );
    });
  });

  const menuLinks = document.querySelectorAll('.priorities-menu-link');
  const priorityItems = document.querySelectorAll('.priority-item');

  menuLinks.forEach(link => {
    link.addEventListener('click', e => {
      e.preventDefault();
      const id = link.getAttribute('href').slice(1);
      const target = document.getElementById(id);
      if (!target) return;

      if (!target.open) target.querySelector('summary').click();

      setTimeout(() => {
        const y = target.getBoundingClientRect().top + window.scrollY - 24;
        window.scrollTo({ top: y, behavior: 'smooth' });
      }, 220);

      link.classList.add('is-active');
    });
  });